import type { UserRole } from '@wineryxplorer/shared';
import { RoleBadge } from './UserIdentity';

interface AdminUserRoleSelectorModalProps {
  userLabel: string;
  currentRole: UserRole;
  promotableRoles: UserRole[];
  selectedRole: UserRole | null;
  onSelectRole: (role: UserRole) => void;
  onCancel: () => void;
  onContinue: () => void;
}

export const AdminUserRoleSelectorModal = ({
  userLabel,
  currentRole,
  promotableRoles,
  selectedRole,
  onSelectRole,
  onCancel,
  onContinue,
}: AdminUserRoleSelectorModalProps) => (
  <div
    className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
    onClick={(e) => {
      if (e.target === e.currentTarget) {
        onCancel();
      }
    }}
  >
    <div className="bg-gray-50 rounded-lg shadow-xl max-w-md w-full">
      <div className="p-6 border-b border-gray-200">
        <h3 className="text-lg font-semibold text-gray-900">Change Role</h3>
      </div>
      <div className="p-6 space-y-4">
        <p className="text-gray-600">
          Select a new role for {userLabel}. Current role: <RoleBadge role={currentRole} />
        </p>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">New Role</label>
          <select
            value={selectedRole || ''}
            onChange={(e) => onSelectRole(e.target.value as UserRole)}
            className="w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-info-500 focus:ring-1 focus:ring-info-500 outline-none"
          >
            <option value="">Select a role...</option>
            {promotableRoles.map((role) => (
              <option key={role} value={role}>
                {role.replace('_', ' ')}
              </option>
            ))}
          </select>
        </div>
      </div>
      <div className="p-6 border-t border-gray-200 flex justify-end space-x-3">
        <button
          onClick={onCancel}
          className="px-4 py-2 text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors"
        >
          Cancel
        </button>
        <button
          onClick={onContinue}
          disabled={!selectedRole}
          className="px-4 py-2 bg-primary-600 hover:bg-primary-700 text-white rounded-lg transition-colors disabled:opacity-50"
        >
          Continue
        </button>
      </div>
    </div>
  </div>
);
